namespace GeniuzPOS.ReportMasterData {
    export class Report_1320Columns {
        static columnsKey = 'ReportMasterData.Report_1320';
    }
}
